import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsUtility = {
	utility_gray_50: colors.primary.grayLight[50],
	utility_gray_100: colors.primary.grayLight[100],
	utility_gray_200: colors.primary.grayLight[200],
	utility_gray_300: colors.primary.grayLight[300],
	utility_gray_400: colors.primary.grayLight[400],
	utility_gray_500: colors.primary.grayLight[500],
	utility_gray_600: colors.primary.grayLight[600],
	utility_gray_700: colors.primary.grayLight[700],
	utility_gray_800: colors.primary.grayLight[800],
	utility_gray_900: colors.primary.grayLight[900],
	utility_gray_50_dark: colors.primary.grayDark[900],
	utility_gray_100_dark: colors.primary.grayDark[800],
	utility_gray_200_dark: colors.primary.grayDark[700],
	utility_gray_300_dark: colors.primary.grayDark[700],
	utility_gray_400_dark: colors.primary.grayDark[600],
	utility_gray_500_dark: colors.primary.grayDark[500],
	utility_gray_600_dark: colors.primary.grayDark[400],
	utility_gray_700_dark: colors.primary.grayDark[300],
	utility_gray_800_dark: colors.primary.grayDark[200],
	utility_gray_900_dark: colors.primary.grayDark[100],

	utility_brand_50: colors.primary.brand[50],
	utility_brand_100: colors.primary.brand[100],
	utility_brand_200: colors.primary.brand[200],
	utility_brand_300: colors.primary.brand[300],
	utility_brand_400: colors.primary.brand[400],
	utility_brand_500: colors.primary.brand[500],
	utility_brand_600: colors.primary.brand[600],
	utility_brand_700: colors.primary.brand[700],
	utility_brand_800: colors.primary.brand[800],
	utility_brand_900: colors.primary.brand[900],
	utility_brand_50_dark: colors.primary.brand[950],
	utility_brand_100_dark: colors.primary.brand[900],
	utility_brand_200_dark: colors.primary.brand[800],
	utility_brand_300_dark: colors.primary.brand[700],
	utility_brand_400_dark: colors.primary.brand[600],
	utility_brand_500_dark: colors.primary.brand[500],
	utility_brand_600_dark: colors.primary.brand[400],
	utility_brand_700_dark: colors.primary.brand[300],
	utility_brand_800_dark: colors.primary.brand[200],
	utility_brand_900_dark: colors.primary.brand[100],

	utility_brand_alt_50: colors.primary.brand[50],
	utility_brand_alt_100: colors.primary.brand[100],
	utility_brand_alt_200: colors.primary.brand[200],
	utility_brand_alt_300: colors.primary.brand[300],
	utility_brand_alt_400: colors.primary.brand[400],
	utility_brand_alt_500: colors.primary.brand[500],
	utility_brand_alt_600: colors.primary.brand[600],
	utility_brand_alt_700: colors.primary.brand[700],
	utility_brand_alt_800: colors.primary.brand[800],
	utility_brand_alt_900: colors.primary.brand[900],
	utility_brand_alt_50_dark: colors.primary.brand[900],
	utility_brand_alt_100_dark: colors.primary.brand[800],
	utility_brand_alt_200_dark: colors.primary.brand[700],
	utility_brand_alt_300_dark: colors.primary.brand[700],
	utility_brand_alt_400_dark: colors.primary.brand[600],
	utility_brand_alt_500_dark: colors.primary.brand[500],
	utility_brand_alt_600_dark: colors.primary.brand[400],
	utility_brand_alt_700_dark: colors.primary.brand[300],
	utility_brand_alt_800_dark: colors.primary.brand[200],
	utility_brand_alt_900_dark: colors.primary.brand[100],

	utility_error_50: colors.primary.error[50],
	utility_error_100: colors.primary.error[100],
	utility_error_200: colors.primary.error[200],
	utility_error_300: colors.primary.error[300],
	utility_error_400: colors.primary.error[400],
	utility_error_500: colors.primary.error[500],
	utility_error_600: colors.primary.error[600],
	utility_error_700: colors.primary.error[700],
	utility_error_50_dark: colors.primary.error[950],
	utility_error_100_dark: colors.primary.error[900],
	utility_error_200_dark: colors.primary.error[800],
	utility_error_300_dark: colors.primary.error[700],
	utility_error_400_dark: colors.primary.error[600],
	utility_error_500_dark: colors.primary.error[500],
	utility_error_600_dark: colors.primary.error[400],
	utility_error_700_dark: colors.primary.error[300],

	utility_warning_50: colors.primary.warning[50],
	utility_warning_100: colors.primary.warning[100],
	utility_warning_200: colors.primary.warning[200],
	utility_warning_300: colors.primary.warning[300],
	utility_warning_400: colors.primary.warning[400],
	utility_warning_500: colors.primary.warning[500],
	utility_warning_600: colors.primary.warning[600],
	utility_warning_700: colors.primary.warning[700],
	utility_warning_50_dark: colors.primary.warning[950],
	utility_warning_100_dark: colors.primary.warning[900],
	utility_warning_200_dark: colors.primary.warning[800],
	utility_warning_300_dark: colors.primary.warning[700],
	utility_warning_400_dark: colors.primary.warning[600],
	utility_warning_500_dark: colors.primary.warning[500],
	utility_warning_600_dark: colors.primary.warning[400],
	utility_warning_700_dark: colors.primary.warning[300],

	utility_success_50: colors.primary.warning[50],
	utility_success_100: colors.primary.warning[100],
	utility_success_200: colors.primary.warning[200],
	utility_success_300: colors.primary.warning[300],
	utility_success_400: colors.primary.warning[400],
	utility_success_500: colors.primary.warning[500],
	utility_success_600: colors.primary.warning[600],
	utility_success_700: colors.primary.warning[700],
	utility_success_50_dark: colors.primary.warning[950],
	utility_success_100_dark: colors.primary.warning[900],
	utility_success_200_dark: colors.primary.warning[800],
	utility_success_300_dark: colors.primary.warning[700],
	utility_success_400_dark: colors.primary.warning[600],
	utility_success_500_dark: colors.primary.warning[500],
	utility_success_600_dark: colors.primary.warning[400],
	utility_success_700_dark: colors.primary.warning[300],

	utility_gray_blue_50: colors.secondary.grayBlue[50],
	utility_gray_blue_100: colors.secondary.grayBlue[100],
	utility_gray_blue_200: colors.secondary.grayBlue[200],
	utility_gray_blue_300: colors.secondary.grayBlue[300],
	utility_gray_blue_400: colors.secondary.grayBlue[400],
	utility_gray_blue_500: colors.secondary.grayBlue[500],
	utility_gray_blue_600: colors.secondary.grayBlue[600],
	utility_gray_blue_700: colors.secondary.grayBlue[700],
	utility_gray_blue_50_dark: colors.secondary.grayBlue[950],
	utility_gray_blue_100_dark: colors.secondary.grayBlue[900],
	utility_gray_blue_200_dark: colors.secondary.grayBlue[800],
	utility_gray_blue_300_dark: colors.secondary.grayBlue[700],
	utility_gray_blue_400_dark: colors.secondary.grayBlue[600],
	utility_gray_blue_500_dark: colors.secondary.grayBlue[500],
	utility_gray_blue_600_dark: colors.secondary.grayBlue[400],
	utility_gray_blue_700_dark: colors.secondary.grayBlue[300],

	utility_blue_light_50: colors.secondary.blueLight[50],
	utility_blue_light_100: colors.secondary.blueLight[100],
	utility_blue_light_200: colors.secondary.blueLight[200],
	utility_blue_light_300: colors.secondary.blueLight[300],
	utility_blue_light_400: colors.secondary.blueLight[400],
	utility_blue_light_500: colors.secondary.blueLight[500],
	utility_blue_light_600: colors.secondary.blueLight[600],
	utility_blue_light_700: colors.secondary.blueLight[700],
	utility_blue_light_50_dark: colors.secondary.blueLight[950],
	utility_blue_light_100_dark: colors.secondary.blueLight[900],
	utility_blue_light_200_dark: colors.secondary.blueLight[800],
	utility_blue_light_300_dark: colors.secondary.blueLight[700],
	utility_blue_light_400_dark: colors.secondary.blueLight[600],
	utility_blue_light_500_dark: colors.secondary.blueLight[500],
	utility_blue_light_600_dark: colors.secondary.blueLight[400],
	utility_blue_light_700_dark: colors.secondary.blueLight[300],

	utility_blue_50: colors.secondary.blue[50],
	utility_blue_100: colors.secondary.blue[100],
	utility_blue_200: colors.secondary.blue[200],
	utility_blue_300: colors.secondary.blue[300],
	utility_blue_400: colors.secondary.blue[400],
	utility_blue_500: colors.secondary.blue[500],
	utility_blue_600: colors.secondary.blue[600],
	utility_blue_700: colors.secondary.blue[700],
	utility_blue_50_dark: colors.secondary.blue[950],
	utility_blue_100_dark: colors.secondary.blue[900],
	utility_blue_200_dark: colors.secondary.blue[800],
	utility_blue_300_dark: colors.secondary.blue[700],
	utility_blue_400_dark: colors.secondary.blue[600],
	utility_blue_500_dark: colors.secondary.blue[500],
	utility_blue_600_dark: colors.secondary.blue[400],
	utility_blue_700_dark: colors.secondary.blue[300],

	utility_blue_dark_50: colors.secondary.blueDark[50],
	utility_blue_dark_100: colors.secondary.blueDark[100],
	utility_blue_dark_200: colors.secondary.blueDark[200],
	utility_blue_dark_300: colors.secondary.blueDark[300],
	utility_blue_dark_400: colors.secondary.blueDark[400],
	utility_blue_dark_500: colors.secondary.blueDark[500],
	utility_blue_dark_600: colors.secondary.blueDark[600],
	utility_blue_dark_700: colors.secondary.blueDark[700],
	utility_blue_dark_50_dark: colors.secondary.blueDark[950],
	utility_blue_dark_100_dark: colors.secondary.blueDark[900],
	utility_blue_dark_200_dark: colors.secondary.blueDark[800],
	utility_blue_dark_300_dark: colors.secondary.blueDark[700],
	utility_blue_dark_400_dark: colors.secondary.blueDark[600],
	utility_blue_dark_500_dark: colors.secondary.blueDark[500],
	utility_blue_dark_600_dark: colors.secondary.blueDark[400],
	utility_blue_dark_700_dark: colors.secondary.blueDark[300],

	utility_indigo_50: colors.secondary.purple[50],
	utility_indigo_100: colors.secondary.indigo[100],
	utility_indigo_200: colors.secondary.indigo[200],
	utility_indigo_300: colors.secondary.indigo[300],
	utility_indigo_400: colors.secondary.indigo[400],
	utility_indigo_500: colors.secondary.indigo[500],
	utility_indigo_600: colors.secondary.indigo[600],
	utility_indigo_700: colors.secondary.indigo[700],
	utility_indigo_50_dark: colors.secondary.indigo[950],
	utility_indigo_100_dark: colors.secondary.indigo[900],
	utility_indigo_200_dark: colors.secondary.indigo[800],
	utility_indigo_300_dark: colors.secondary.indigo[700],
	utility_indigo_400_dark: colors.secondary.indigo[600],
	utility_indigo_500_dark: colors.secondary.indigo[500],
	utility_indigo_600_dark: colors.secondary.indigo[400],
	utility_indigo_700_dark: colors.secondary.indigo[300],

	utility_purple_50: colors.secondary.purple[50],
	utility_purple_100: colors.secondary.purple[100],
	utility_purple_200: colors.secondary.purple[200],
	utility_purple_300: colors.secondary.purple[300],
	utility_purple_400: colors.secondary.purple[400],
	utility_purple_500: colors.secondary.purple[500],
	utility_purple_600: colors.secondary.purple[600],
	utility_purple_700: colors.secondary.purple[700],
	utility_purple_50_dark: colors.secondary.purple[950],
	utility_purple_100_dark: colors.secondary.purple[900],
	utility_purple_200_dark: colors.secondary.purple[800],
	utility_purple_300_dark: colors.secondary.purple[700],
	utility_purple_400_dark: colors.secondary.purple[600],
	utility_purple_500_dark: colors.secondary.purple[500],
	utility_purple_600_dark: colors.secondary.purple[400],
	utility_purple_700_dark: colors.secondary.purple[300],

	utility_fuchsia_50: colors.secondary.fuchsia[50],
	utility_fuchsia_100: colors.secondary.fuchsia[100],
	utility_fuchsia_200: colors.secondary.fuchsia[200],
	utility_fuchsia_300: colors.secondary.fuchsia[300],
	utility_fuchsia_400: colors.secondary.fuchsia[400],
	utility_fuchsia_500: colors.secondary.fuchsia[500],
	utility_fuchsia_600: colors.secondary.fuchsia[600],
	utility_fuchsia_700: colors.secondary.fuchsia[700],
	utility_fuchsia_50_dark: colors.secondary.fuchsia[950],
	utility_fuchsia_100_dark: colors.secondary.fuchsia[900],
	utility_fuchsia_200_dark: colors.secondary.fuchsia[800],
	utility_fuchsia_300_dark: colors.secondary.fuchsia[700],
	utility_fuchsia_400_dark: colors.secondary.fuchsia[600],
	utility_fuchsia_500_dark: colors.secondary.fuchsia[500],
	utility_fuchsia_600_dark: colors.secondary.fuchsia[400],
	utility_fuchsia_700_dark: colors.secondary.fuchsia[300],

	utility_pink_50: colors.secondary.pink[50],
	utility_pink_100: colors.secondary.pink[100],
	utility_pink_200: colors.secondary.pink[200],
	utility_pink_300: colors.secondary.pink[300],
	utility_pink_400: colors.secondary.pink[400],
	utility_pink_500: colors.secondary.pink[500],
	utility_pink_600: colors.secondary.pink[600],
	utility_pink_700: colors.secondary.pink[700],
	utility_pink_50_dark: colors.secondary.pink[950],
	utility_pink_100_dark: colors.secondary.pink[900],
	utility_pink_200_dark: colors.secondary.pink[800],
	utility_pink_300_dark: colors.secondary.pink[700],
	utility_pink_400_dark: colors.secondary.pink[600],
	utility_pink_500_dark: colors.secondary.pink[500],
	utility_pink_600_dark: colors.secondary.pink[400],
	utility_pink_700_dark: colors.secondary.pink[300],

	utility_orange_dark_50: colors.secondary.orangeDark[50],
	utility_orange_dark_100: colors.secondary.orangeDark[100],
	utility_orange_dark_200: colors.secondary.orangeDark[200],
	utility_orange_dark_300: colors.secondary.orangeDark[300],
	utility_orange_dark_400: colors.secondary.orangeDark[400],
	utility_orange_dark_500: colors.secondary.orangeDark[500],
	utility_orange_dark_600: colors.secondary.orangeDark[600],
	utility_orange_dark_700: colors.secondary.orangeDark[700],
	utility_orange_dark_50_dark: colors.secondary.orangeDark[950],
	utility_orange_dark_100_dark: colors.secondary.orangeDark[900],
	utility_orange_dark_200_dark: colors.secondary.orangeDark[800],
	utility_orange_dark_300_dark: colors.secondary.orangeDark[700],
	utility_orange_dark_400_dark: colors.secondary.orangeDark[600],
	utility_orange_dark_500_dark: colors.secondary.orangeDark[500],
	utility_orange_dark_600_dark: colors.secondary.orangeDark[400],
	utility_orange_dark_700_dark: colors.secondary.orangeDark[300],

	utility_orange_50: colors.secondary.orange[50],
	utility_orange_100: colors.secondary.orange[100],
	utility_orange_200: colors.secondary.orange[200],
	utility_orange_300: colors.secondary.orange[300],
	utility_orange_400: colors.secondary.orange[400],
	utility_orange_500: colors.secondary.orange[500],
	utility_orange_600: colors.secondary.orange[600],
	utility_orange_700: colors.secondary.orange[700],
	utility_orange_50_dark: colors.secondary.orange[950],
	utility_orange_100_dark: colors.secondary.orange[900],
	utility_orange_200_dark: colors.secondary.orange[800],
	utility_orange_300_dark: colors.secondary.orange[700],
	utility_orange_400_dark: colors.secondary.orange[600],
	utility_orange_500_dark: colors.secondary.orange[500],
	utility_orange_600_dark: colors.secondary.orange[400],
	utility_orange_700_dark: colors.secondary.orange[300],
};
